<template>
  <div class="footer-area-wrapper" :class="FooterStyle">
    <div class="footer-area section-space--ptb_90">
      <div class="container">
        <div class="row footer-widget-wrapper">
          <div class="col-lg-4 col-md-6 footer-widget">
            <div class="footer-widget__logo mb-30">
              <router-link to="/">
                <img
                  src="../assets/img/logo/logo-primary.png"
                  class="img-fluid logo-dark"
                  alt
                />
                <img
                  src="../assets/img/logo/logo-primary.png"
                  class="img-fluid logo-light"
                  alt
                />
              </router-link>
            </div>
          </div>
          <div class="col-lg-2 col-md-6 footer-widget">
            <h6 class="footer-widget__title mb-20">APIF</h6>
            <ul class="footer-widget__list">
              <li>hello@apif.app</li>
            </ul>
          </div>
          <div class="col-lg-2 col-md-6 footer-widget">
            <h6 class="footer-widget__title mb-20">LEGAL</h6>
            <ul class="footer-widget__list">
              <li>
                <router-link :to="{ path: 'privacy' }"
                  >Privacy Policy</router-link
                >
              </li>
              <li>
                <router-link :to="{ path: 'terms' }"
                  >Terms of Service</router-link
                >
              </li>
            </ul>
          </div>
          <div class="col-lg-2 col-md-6 footer-widget">
            <h6 class="footer-widget__title mb-20">APP</h6>
            <ul class="footer-widget__list">
              <li>
                <a href="https://go.apif.app/#/signin" class="hover-style-link"
                  >Login</a
                >
              </li>
              <li>
                <a
                  href="https://go.apif.app/#/signup"
                  class="hover-style-link signup"
                  >Sign up</a
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!--
    <div class="footer-copyright-area border-top section-space--ptb_30">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-6 text-center text-md-right">
            <ul class="list ht-social-networks solid-rounded-icon">
              <li class="item">
                <a href="#" target="_blank" class="social-link">
                  <i class="fab fa-facebook social-link-icon"></i>
                </a>
              </li>
              <li class="item">
                <a href="#" target="_blank" class="social-link">
                  <i class="fab fa-twitter social-link-icon"></i>
                </a>
              </li>
              <li class="item">
                <a href="#" target="_blank" class="social-link">
                  <i class="fab fa-instagram social-link-icon"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    -->
  </div>
</template>

<script>
export default {
  name: "FooterMain",
  props: ["FooterStyle"],
};
</script>

<style scoped>
.footer-area-wrapper {
  background-image: linear-gradient(#e4e4e4, #fff);
}
</style>